import { render, staticRenderFns } from "./studentParticular.vue?vue&type=template&id=4b16b35d&scoped=true"
import script from "./studentParticular.vue?vue&type=script&lang=js"
export * from "./studentParticular.vue?vue&type=script&lang=js"
import style0 from "./studentParticular.vue?vue&type=style&index=0&id=4b16b35d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b16b35d",
  null
  
)

export default component.exports